export const LOGIN = "/login";
export const DASHBOARD = "/";
export const SETTINGS = "/settings";
